export default __webpack_public_path__ + "static/media/kailabaWeb.3cff6c71.png";